import type { PipelineStage } from './types';

/** Translation key, in the `registration` namespace, for each stage's name. */
export const STAGE_LABEL_KEYS = {
  registration: 'stageRegistration',
  sticking: 'stageSticking',
  review: 'stageReview',
  ready_for_packing: 'stageReadyForPacking',
  reception: 'stageReception',
  sorting: 'stageSorting',
  handover_scanning: 'stageHandoverScanning',
  photo_scanning: 'stagePhotoScanning',
  qr_review: 'stageQrReview',
  ocr: 'stageOcr',
  qa1_ocr: 'stageQa1Ocr',
  qa2_ocr: 'stageQa2Ocr',
  qa3_ocr: 'stageQa3Ocr',
  warehouse: 'stageWarehouse',
  archived: 'stageArchived'
} as const satisfies Record<PipelineStage, string>;

export type StageLabelKey = (typeof STAGE_LABEL_KEYS)[PipelineStage];

function isLabelledStage(stage: string): stage is PipelineStage {
  return stage in STAGE_LABEL_KEYS;
}

/**
 * Multi-select filter options for a stage column, in pipeline order —
 * everything from `from` onward when given (a stage screen lists its own stage
 * and what follows), otherwise every stage. Stages this build has no label for
 * are skipped.
 */
export function stageFilterOptions(
  order: readonly string[],
  label: (key: StageLabelKey) => string,
  from?: PipelineStage
): { label: string; value: PipelineStage }[] {
  const start = from ? Math.max(0, order.indexOf(from)) : 0;

  return order
    .slice(start)
    .filter(isLabelledStage)
    .map((stage) => ({ label: label(STAGE_LABEL_KEYS[stage]), value: stage }));
}
